// DonutProgress.jsx
import React from "react";

export default function DonutProgress({ value = 0, size = 120, strokeWidth = 12 }) {
    const clamped = Math.max(0, Math.min(100, value));
    const radius = (size - strokeWidth) / 2;
    const C = 2 * Math.PI * radius;              // circumference
    const dashOffset = C * (1 - clamped / 100);  // how much to "hide"

    return (
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
            <g transform={`rotate(-90 ${size/2} ${size/2})`}>
                {/* track */}
                <circle
                    cx={size/2}
                    cy={size/2}
                    r={radius}
                    stroke="#d9d9d9"
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                {/* progress */}
                <circle
                    cx={size/2}
                    cy={size/2}
                    r={radius}
                    stroke="#333"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    fill="none"
                    strokeDasharray={C}
                    strokeDashoffset={dashOffset}
                    style={{ transition: "stroke-dashoffset 600ms ease" }}
                />
            </g>

            {/* centered % text */}
            <text
                x="50%" y="50%"
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize={size * 0.28}
                fontWeight={600}
                fill="#333"
            >
                {clamped}%
            </text>
        </svg>
    );
}
